import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * This component handles tracking QR code scans.
 * It should be included in the main App component to track all routes.
 */
const QRCodeTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    const trackQRScan = async () => {
      // Parse URL parameters
      const searchParams = new URLSearchParams(location.search);
      const qrCode = searchParams.get('qr');
      
      // If QR code parameter exists, track the scan
      if (qrCode && qrCode.startsWith('v_')) {
        try {
          // Get user agent info
          const userAgent = navigator.userAgent;
          
          // Call the tracking function
          await supabase.rpc('register_qr_scan', {
            tracking_id_param: qrCode,
            user_agent_param: userAgent
          });
          
          // Remove QR parameter from URL to prevent duplicate tracking on refresh
          // but keep the rest of the query parameters intact
          const newParams = new URLSearchParams(searchParams);
          newParams.delete('qr');
          
          // Update URL without reloading the page
          const newSearch = newParams.toString();
          const newPath = newSearch 
            ? `${location.pathname}?${newSearch}` 
            : location.pathname;
            
          window.history.replaceState(
            {}, 
            '', 
            newPath + location.hash
          );
          
          
        } catch (error) {
          console.error('Error tracking QR code scan:', error);
        }
      }
    };
    
    trackQRScan();
  }, [location]);
  
  // This component doesn't render anything
  return null;
};

export default QRCodeTracker;